import React from "react"

export default () => (
    <div className="circleE">
        <svg xmlns="http://www.w3.org/2000/svg" width="382" height="519" viewBox="0 0 382 519"><path class="circleEsvg" d="M137,506.324V48.64A258.582,258.582,0,0,1,259.5,18C402.818,18,519,134.182,519,277.5S402.818,537,259.5,537A258.325,258.325,0,0,1,137,506.324Z" transform="translate(-137 -18)"/></svg>
    </div>
)